import React, { Component } from "react";
import CostForm from "./CostForm/CostForm";
import SmallModal from "../../../hoc/UI/SmallModal/SmallModal";
import { Button } from "rsuite";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';


class Cost extends Component {
  state = {
    mode: 1
  };


  componentDidMount() {
    this.props.methods.fetch();
  }

  render() {
    let smallModal = null;

    if (this.props.showSmallModal) {
      smallModal = (
        <SmallModal>
          <CostForm
            currentProjectID={this.props.currentProjectID}
            toggleSmallModalHandler={this.props.toggleSmallModalHandler}
            currentCost={
              this.state.project_cost_id === null
                ? null
                : this.props.items.filter(
                    item => item.project_cost_id === this.state.project_cost_id
                  )[0]
            }
            methods={this.props.methods}
            disabled={this.props.disabled}
          />
        </SmallModal>
      );
    }

    const role = localStorage.getItem("project_role");
    //const DataStatusName = ["Draft", "Submitted", "Published"];
    let shownItems = this.props.items.filter(
      item => item.data_status_id === this.state.mode
    );

    const projectTableBody = shownItems.map(item => {
      return (
        <tr
          key={item.project_cost_id}
          onClick={e => {
            if (e.target.type !== "button") {
              this.setState({
                project_cost_id: item.project_cost_id
              });
              this.props.toggleSmallModalHandler();
            }
          }}
        >
          <td>{item.cost_name_type_lkp.cost_name}</td>
          <td>{item.cost_name_type_lkp.cost_type}</td>
          <td>{item.cost_value}</td>
          <td>{item.cost_description}</td>
        </tr>
      );
    });

    return (
        <div>
            {this.props.disabled ? null : (
              <div
                  style={{textAlign: "right"}}
              >
              <Button
                  color={"blue"}
                  onClick={() => {
                    this.setState({ project_cost_id: null });
                    this.props.toggleSmallModalHandler();
                  }}
              >
                Create New Cost
              </Button>
              </div>
            )}


          <Tabs defaultIndex={this.state.mode ? this.state.mode - 1 : 0} >
            <TabList>
              <Tab onClick={() => this.setState({mode: 1})}>Draft</Tab>
              {role === "ROLE_USER" ? null : (
                <Tab onClick={() => this.setState({mode: 2})}>Pending Approval</Tab>
              )}
              <Tab onClick={() => this.setState({mode: 3})}>Published</Tab>
            </TabList>

              <TabPanel></TabPanel>
              {role === "ROLE_USER" ? null : (
                  <TabPanel></TabPanel>
              )}
              <TabPanel></TabPanel>
          </Tabs>


        {smallModal}


        <table className="table">
          <thead>
            <tr>
              <th>Cost Name</th>
              <th>Cost Type</th>
              <th>Cost Value</th>
              <th>Cost Description</th>
            </tr>
          </thead>
          <tbody>{projectTableBody}</tbody>
        </table>
        </div>
    );
  }
}

export default Cost;
